export class FormPeselValidator {
  private PESEL: number[] = new Array(11);
  private valid = false;

  public validate(PESELNumber: string): boolean {
    if (PESELNumber.length !== 11) {
      return false;
    }

    for (let i = 0; i < 11; i++) {
        this.PESEL[i] = parseInt(PESELNumber.substring(i, i + 1));
      }

    this.valid = this.checkSum() && this.checkMonth() && this.checkDay();

    return this.valid;
  }

  private getBirthYear(): number {
    let year = 10 * this.PESEL[0] + this.PESEL[1];
    const month = this.getBirthMonth();

    if (month > 80 && month < 93) {
      year += 1800;
    } else if (month > 0 && month < 13) {
      year += 1900;
    } else if (month > 20 && month < 33) {
      year += 2000;
    } else if (month > 40 && month < 53) {
      year += 2100;
    } else if (month > 60 && month < 73) {
      year += 2200;
    }

    return year;
  }

  private getBirthMonth(): number {
    let month = 10 * this.PESEL[2] + this.PESEL[3];

    if (month > 80 && month < 93) {
      month -= 80;
    } else if (month > 20 && month < 33) {
      month -= 20;
    } else if (month > 40 && month < 53) {
      month -= 40;
    } else if (month > 60 && month < 73) {
      month -= 60;
    }

    return month;
  }

  public getBirthDay(): number {
    return 10 * this.PESEL[4] + this.PESEL[5];
  }

  private checkSum(): boolean {
    const weights = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
    let sum = 0;

    for (let i = 0; i < weights.length; i++) {
      sum += this.PESEL[i] * weights[i];
    }

    const rest = sum % 10;

    return rest === this.PESEL[10];
  }

  private checkMonth(): boolean {
    const month = this.getBirthMonth();

    return month > 0 && month < 13;
  }

  private checkDay(): boolean {
    const year = this.getBirthYear();
    const month = this.getBirthMonth();
    const day = this.getBirthDay();

    if ((day > 0 && day < 32) &&
      (month === 1 || month === 3 || month === 5 ||
        month === 7 || month === 8 || month === 10 ||
        month === 12)) {
      return true;
    } else if ((day > 0 && day < 31) &&
      (month === 4 || month === 6 || month === 9 ||
        month === 11)) {
      return true;
    } else { return (day > 0 && day < 30 && this.leapYear(year)) ||
      (day > 0 && day < 29 && !this.leapYear(year));
    }
  }

  private leapYear(year: number): boolean {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }
}


